// sub_rol contable tiene 3 variantes reales en la BD ("cont", "conta", "contabilid" —
// típeos/abreviaciones del mismo rol, confirmado en vivo), por eso se matchea por
// prefijo en vez de comparar contra un único string. Mismo criterio que usa el backend
// en cajaChicaController.js.
export const esSubRolContable = (subRol) => String(subRol || "").toLowerCase().startsWith("cont");

// Gate de "admin, gerente o contable" reusado por varias acciones restringidas del
// módulo (crear items, editar ingresos).
export const esRolAdminGerenteContable = (user) =>
  user?.role === "admin" || user?.role === "gerente" || esSubRolContable(user?.sub_rol);
